module.exports = new __parcel__URL__("battle_royale_button_bg.b1dec4fd.png").toString();